export default (function () {
  if (window.attribution && window.attribution.settings && window.attribution.settings().debug) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.log.apply(console.log, ["[Attribution.js]"].concat(args));
  }
});
export var error = function error() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  console.error.apply(console.error, ["[Attribution.js]"].concat(args));
};